import Request from 'src/utils/request'

/**
 * 根据指标获取组件数据
 */
export const getIndicatorDataApi = (id, data) => {
  const { provinceCode, cityCode, regionCode } = data
  const searchParam = {
    ...data,
    provinceFlag: provinceCode ? 1 : 0,
    cityFlag: cityCode ? 1 : 0,
    regionFlag: regionCode ? 1 : 0,
  }
  return Request({
    url: `/indicators/${id}/data`,
    method: 'get',
    params: searchParam,
    unique: true,
  })
}

/** 地图组件专用：新指标数据接口（其它图表仍用 getIndicatorDataApi） */
export const getIndicatorDataUpApi = (id, data) => {
  const { provinceCode, cityCode, regionCode } = data || {}
  const searchParam = {
    ...(data || {}),
    provinceFlag: provinceCode ? 1 : 0,
    cityFlag: cityCode ? 1 : 0,
    regionFlag: regionCode ? 1 : 0,
  }
  return Request({
    url: `/indicators/${id}/data_up`,
    method: 'get',
    params: searchParam,
    unique: true,
  })
}
/**
 * 保存组件指标数据
 */
export function getSaveComponentDataApi (data) {
  return Request({
    url: '/panel/chart_data',
    method: 'post',
    unique: true,
    data: data,
  })
}
